import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "caption" }
const _hoisted_2 = { class: "dialog-detail mt-s2" }
const _hoisted_3 = { class: "flex dialog-data justify-content-between align-items-center mt-s3" }
const _hoisted_4 = { class: "caption" }
const _hoisted_5 = {
  key: 0,
  class: "flex mt-s2 align-items-center"
}
const _hoisted_6 = { class: "caption mr-s2" }
const _hoisted_7 = { class: "caption mt-s4" }
const _hoisted_8 = { class: "text-center dialog-detail mt-s2" }
const _hoisted_9 = { class: "caption mt-s3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Fee and Price Impact ")
const _hoisted_11 = {
  key: 2,
  class: "flex mt-s4 dialog-detail align-items-center justify-content-between"
}
const _hoisted_12 = { class: "dialog-footer dialog-footer-two-btn" }

import BigNumber from 'bignumber.js';
import { computed, ref } from 'vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { Token } from '@/sdk/entities/token';
import Callout from '@/components/Callout.vue';
import { format, printUSD, formatPercentage } from '@/utils/format';
import { useI18n } from 'vue-i18n';
import networks from '@/helpers/networks';
import Caption from '@/components/Caption.vue';
import LpAmountFormat from '@/components/LpAmountFormat.vue';
import PriceImpactWarning from '@/views/pages/liquidity/portfolios/portfolio/confirmation/PriceImpactWarning.vue';
import { WITHDRAW_PRICE_IMPACT_WARNING_PERCENT_FORM } from '@/helpers/constants';
import { PERCENTAGE_DECIMAL_PRECISION } from '@/constants/INTERFACE_SETTINGS';
import { useEasyModeForm } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawConfirmation',
  props: {
    portfolioName: null,
    impactPercent: null,
    impactUSD: null,
    withdrawTokens: null,
    withdrawTokensUsdEquivalent: null,
    lpTokens: null,
    destinationChain: null,
    crossChainFeeUSD: null,
    crossChainFeePercent: null
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'submit'): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolioName: string;
  impactPercent: BigNumber;
  impactUSD: BigNumber;
  withdrawTokens: { token: Token; amount: BigNumber }[];
  withdrawTokensUsdEquivalent: BigNumber;
  lpTokens: BigNumber;
  destinationChain?: string | number | null;
  crossChainFeeUSD?: BigNumber | null;
  crossChainFeePercent?: BigNumber | null;
}

const { t } = useI18n();
const { easyModeForm } = useEasyModeForm();





const isWarningDialogShown = ref(false);

const impactPercentInfo = computed(() => {
  if (props.impactPercent.eq(0)) {
    return {
      type: 'success',
      value: '0',
    };
  }

  const smallFeeLimit = '0.01';
  if (props.impactPercent.isLessThanOrEqualTo(smallFeeLimit)) {
    return {
      type: 'success',
      value: '< 0.01',
    };
  }

  return {
    type: 'warning',
    value: props.impactPercent.decimalPlaces(2).toString(),
  };
});
const chainIconPath = computed(() =>
  props.destinationChain ? networks[props.destinationChain].iconLink : '',
);
const crossChainFeeForPrint = computed(
  () =>
    `${printUSD(props.crossChainFeeUSD ?? '0')} (${
      props.crossChainFeePercent ? formatPercentage(props.crossChainFeePercent) : '--'
    }%)`,
);
const totalEnteredValueInUSD = computed(() =>
  props.lpTokens.multipliedBy(easyModeForm.portfolio.getLpTokenPriceUSD()),
);
const totalReceiveValueInUSD = computed(() => {
  const portfolio = easyModeForm.portfolio;
  const withdrawalAmountInBase = portfolio.getYouWithdrawInBase(props.withdrawTokens);
  return portfolio.priceInUSD.multipliedBy(withdrawalAmountInBase);
});

const openWarningModal = () => {
  isWarningDialogShown.value = true;
};
const closeWarningModal = () => {
  isWarningDialogShown.value = false;
};

const onConfirm = () => {
  if (props.impactPercent.gt(WITHDRAW_PRICE_IMPACT_WARNING_PERCENT_FORM)) {
    openWarningModal();
    return;
  }
  emits('submit');
};
const onCancel = () => {
  closeWarningModal();
  emits('cancel');
};
const onConfirmInWarningModal = () => {
  closeWarningModal();
  emits('submit');
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('portfolio.withdraw.confirmDialog.youWithdraw')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.withdrawTokens, (tokenAndAmount, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tokenAndAmount.token.symbol,
          class: _normalizeClass(["flex justify-content-between", { 'mt-s2': index !== 0 }])
        }, [
          _createVNode(TokenIcon, {
            "icon-src": tokenAndAmount.token.tokenIconUrl,
            symbol: tokenAndAmount.token.unwrapWETH().symbol,
            size: "20",
            full: ""
          }, null, 8, ["icon-src", "symbol"]),
          _createElementVNode("div", null, _toDisplayString(_unref(format)(tokenAndAmount.amount)), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('inUsd')), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(printUSD)(__props.withdrawTokensUsdEquivalent)), 1)
    ]),
    (__props.destinationChain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('portfolio.withdraw.confirmDialog.chainToReceive')), 1),
          _createVNode(TokenIcon, {
            "icon-src": _unref(chainIconPath),
            size: "16"
          }, null, 8, ["icon-src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('portfolio.withdraw.confirmDialog.sendingInPool')), 1),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(LpAmountFormat, { "lp-amount": __props.lpTokens }, null, 8, ["lp-amount"])
    ]),
    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('portfolio.loss.caption')), 1),
    (_unref(impactPercentInfo).type !== 'none')
      ? (_openBlock(), _createBlock(Callout, {
          key: 1,
          type: _unref(impactPercentInfo).type,
          class: "mt-s2"
        }, {
          content: _withCtx(() => [
            _hoisted_10
          ]),
          aside: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(`text-${_unref(impactPercentInfo).type}`)
            }, _toDisplayString(_unref(printUSD)(__props.impactUSD)), 3),
            _createElementVNode("span", null, "(" + _toDisplayString(_unref(impactPercentInfo).value) + "%)", 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    (__props.crossChainFeePercent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(Caption, {
            caption: _ctx.$t('portfolio.crosschainFee.caption'),
            tooltip: _ctx.$t('portfolio.crosschainFee.tooltip')
          }, null, 8, ["caption", "tooltip"]),
          _createElementVNode("div", null, _toDisplayString(_unref(crossChainFeeForPrint)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _ctx.$t('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('portfolio.withdraw.confirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onConfirm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('portfolio.withdraw.confirmDialog.confirmBtn')), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createVNode(_component_Dialog, {
      visible: isWarningDialogShown.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((isWarningDialogShown).value = $event)),
      "show-header": false,
      closable: false,
      dismissableMask: "",
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(PriceImpactWarning, {
          type: "withdraw",
          "impact-percent": __props.impactPercent.decimalPlaces(_unref(PERCENTAGE_DECIMAL_PRECISION)).toNumber(),
          "totally-provide-u-s-d": _unref(totalEnteredValueInUSD),
          "will-receive-u-s-d": _unref(totalReceiveValueInUSD),
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (onCancel())),
          onConfirm: _cache[3] || (_cache[3] = ($event: any) => (onConfirmInWarningModal()))
        }, null, 8, ["impact-percent", "totally-provide-u-s-d", "will-receive-u-s-d"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})